/**
 * Utility module for mapping Amplience schema types to Google Analytics page types.
 * @module AmplienceSchemaMapping
 */

/**
 * Maps Amplience schema types to standardized Google Analytics page types.
 *
 * @param {string} amplienceSchema - The input Amplience schema type.
 * @returns {string} The corresponding Google Analytics page type.
 *
 * @description
 * Converts specific Amplience schema types to more generic GA page types:
 * - 'crossbrand-homepage-newest' → 'home'
 * - 'brand-homepage' → 'subhome'
 * - 'plp-page' → 'category'
 *
 * For unrecognized schemas, returns the original schema type.
 *
 * @example
 * // Returns 'home'
 * mapAmplienceSchemaToGAPageType('crossbrand-homepage-newest')
 *
 * @example
 * // Returns 'custom-schema'
 * mapAmplienceSchemaToGAPageType('custom-schema')
 */
export const mapAmplienceSchemaToGAPageType = (
  amplienceSchema: string
): string => {
  switch (amplienceSchema) {
    case 'crossbrand-homepage-newest':
      return 'home'
    case 'brand-homepage':
      return 'subhome'
    case 'plp-page':
      return 'category'

    default:
      return amplienceSchema
  }
}
